<template>
    <div class="product-slider swiper-container">
        <div class="onsale" v-if="isSale">Скидка!</div>

        <!-- ГЛАВНЫЙ СЛАЙДЕР -->
        <Swiper
            class="swiper gallery-top"
            :modules="[Thumbs, Pagination, Navigation]"
            :thumbs="{ swiper: thumbsSwiper }"
            :spaceBetween="0"
            :slides-per-view="1"
            :pagination="isDesktop ? false : { el: '.swiper-pagination', clickable: true, renderBullet }"
            ref="swiperTop"
        >
            <SwiperSlide v-for="image in images" :key="image.id">
                <div class="product-slide__img">
                    <a class="fancybox" :href="image['w800']" data-fancybox="gallery1">
                        <picture>
                            <source media="(min-width:769px)" :srcset="image['w800']" />
                            <source media="(max-width:768px)" :srcset="image['w500']" />
                            <img class="product-card__img js-lazy-load" :srcset="image['w800']" itemprop="image" alt="" title="" />
                        </picture>
                    </a>
                </div>
            </SwiperSlide>
            <div v-if="!isDesktop" class="swiper-pagination"></div>
        </Swiper>

        <!-- МИНИАТЮРЫ -->
        <Swiper
            v-if="isDesktop"
            class="product-slider__thumbs swiper gallery-thumbs"
            :modules="[Thumbs, Navigation]"
            :spaceBetween="30"
            :slides-per-view="3"
            @swiper="onThumbsSwiper"
            ref="swiperThumbs"
            navigation
        >
            <SwiperSlide v-for="(image, index) in images" :key="image.id">
                <div class="product-slide__img" @click="toSlide(index)">
                    <picture>
                        <source media="(min-width:769px)" :srcset="image['w800']" />
                        <source media="(max-width:768px)" :srcset="image['w500']" />
                        <img class="" :srcset="image['w800']" itemprop="image" alt="" title="" />
                    </picture>
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Thumbs, Pagination, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/thumbs'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import LazyLoad from '@src/js/lazy-load'

const props = defineProps({
    images: Array,
    isSale: Boolean
})

const isDesktop = ref(false)
const swiperTop = ref(null)
const swiperThumbs = ref(null)
const thumbsSwiper = ref(null)

function onThumbsSwiper(swiper) {
    thumbsSwiper.value = swiper
}

onMounted(() => {
    updateIsDesktop()
    window.addEventListener('resize', updateIsDesktop)
    LazyLoad.update && LazyLoad.update()
})

function updateIsDesktop() {
    isDesktop.value = window.matchMedia('(min-width: 993px)').matches
}

function toSlide(index) {
    if (swiperTop.value && swiperTop.value.swiper) {
        swiperTop.value.swiper.slideTo(index, 300)
    }
}

// Кастомная функция для renderBullet
function renderBullet(index, className) {
    return `<div class="${className}"><div class="inner-bullet"></div></div>`
}
</script>

<style scoped>
.swiper-slide-active .product-slide__img {
    border-radius: 4px;
}
</style>
